export default {
  name: 'demo',
  appId: 'wx9e5863e1401b768c',
  wechatId: '8888',
  baseUrl: 'https://demo.estore.d1miao.com/'
};